import { render, staticRenderFns } from "./EditCountry.vue?vue&type=template&id=c1a2c118"
import script from "./EditCountry.vue?vue&type=script&lang=js"
export * from "./EditCountry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports